// @flow
export const notoSansDisplay = {
    fontFamily: `'Noto Sans Display', sans-serif`,
};
